import {Injectable} from '@angular/core';
import {BehaviorSubject, from, Observable} from 'rxjs';
import {ConnectionStatus} from '../interfaces/connection-status';

@Injectable({
  providedIn: 'root',
})
export class ConnectivityService {
  private lastOnlineAt?: Date;
  private connectivityStatusSubject = new BehaviorSubject<ConnectionStatus>({
    isOnline: navigator.onLine,
    hasInternetConnection: navigator.onLine
  });

  constructor() {
    let timout: ReturnType<typeof setTimeout> | undefined
    window.addEventListener('online', () => {
      clearTimeout(timout);
      const offlineTime = this.getLastOnlineTimeInSecs();
      this.connectivityStatusSubject.next({isOnline: true, offlineSeconds: offlineTime, hasInternetConnection: true});
    });

    window.addEventListener('offline', () => {
      this.lastOnlineAt = new Date();
      timout = setTimeout(() => {
        this.connectivityStatusSubject.next({isOnline: false, hasInternetConnection: false});
      }, 30 * 1000);
    });
  }

  get isConnected$(): Observable<ConnectionStatus> {
    return this.connectivityStatusSubject.asObservable();
  }

  setDisconnected() {
    this.lastOnlineAt = new Date();
    from(fetch('https://www.google.com', {mode: 'no-cors'}))
      .subscribe({
        next: () => this.connectivityStatusSubject.next({isOnline: true, hasInternetConnection: true}),
        error: () => this.connectivityStatusSubject.next({isOnline: false, hasInternetConnection: false})
      });
  }

  setConnected() {
    const offlineSeconds = this.getLastOnlineTimeInSecs();
    this.connectivityStatusSubject.next({isOnline: true, offlineSeconds, hasInternetConnection: true});
  }

  private getLastOnlineTimeInSecs() {
    let offlineTime = 0;
    if (this.lastOnlineAt) {
      offlineTime = new Date().getTime() - this.lastOnlineAt?.getTime();
      offlineTime = offlineTime / 1000
    }
    return offlineTime;
  }
}
